export default __webpack_public_path__ + "static/media/90bet_receipt.a15e477b.jpg";